import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export const FAQS = [
  ["What is a PCD Ayurvedic franchise?", "PCD (Propaganda Cum Distribution) lets you sell Saans Wellness products in your territory under a franchise arrangement — with monopoly rights, marketing support and direct-from-plant pricing."],
  ["What investment is required to start?", "Investment depends on your chosen product range and territory. We offer flexible starter packs — talk to our team and we'll tailor a plan to your budget."],
  ["Will I get monopoly rights for my area?", "Yes. We grant exclusive district-level rights so there's no internal competition, letting you build your market with confidence."],
  ["Do you provide marketing material?", "Absolutely. Every partner receives visual aids, product cards, a digital catalogue, MR bags and promotional inputs — free of cost."],
  ["Are your products certified?", "Yes — our facility is WHO-GMP, ISO 9001:2015, ISO 22000 and FSSAI compliant, with AYUSH-approved formulations."],
  ["Do you also do third-party / contract manufacturing?", "Yes. Alongside PCD franchise, we offer third-party, private-label and nutraceutical contract manufacturing at our own GMP facility. Submit an enquiry and mention your requirement."],
];

export default function FAQ() {
  return (
    <section id="faq" className="bg-[#f9f8f5] py-20 md:py-28" data-testid="faq-section">
      <div className="mx-auto max-w-3xl px-5 md:px-8">
        <div className="text-center">
          <div className="eyebrow text-[#d46a1d]">Questions</div>
          <h2 className="mt-3 font-serif text-4xl tracking-tight text-[#202124] md:text-5xl">Frequently asked</h2>
        </div>

        <Accordion type="single" collapsible className="mt-10 space-y-3">
          {FAQS.map(([q, a], i) => (
            <AccordionItem key={i} value={`item-${i}`}
              className="overflow-hidden rounded-xl border border-[#e7e0d6] bg-white px-5 card-shadow" data-testid={`faq-${i}`}>
              <AccordionTrigger className="py-5 text-left font-serif text-lg text-[#202124] hover:no-underline">
                {q}
              </AccordionTrigger>
              <AccordionContent className="pb-5 text-[15px] leading-relaxed text-[#55534e]">
                {a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
